import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection, doc, getDoc } from 'firebase/firestore'

export default class Rubrics extends BaseModel {
  constructor() {
    super(collection(db, 'rubrics'))
  }

  static async get(id: string) {
    try {
      const docSnap = await getDoc(doc(db, 'rubrics', id));
      if (docSnap.exists()) {
        return { data: docSnap.data() };
      } else {
        console.error("No such document!");
        return { data: null };
      }
    } catch (error) {
      console.error("Error getting document:", error);
      return { data: null };
    }
  }
}
